import t from "react";
const o = t.createContext(
  void 0
);
export {
  o as FocusRestoreContext
};
